var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "80%",
              margin: "0 auto",
              "margin-top": "20px",
              "margin-bottom": "20px"
            }
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-form-inline",
                staticStyle: { width: "900px" },
                attrs: { inline: true, model: _vm.form, "label-width": "200px" }
              },
              [
                _c("p", [_vm._v("理货任务生成规则")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "规则起始时间:" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        "value-format": "yyyy-MM-dd",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期"
                      },
                      model: {
                        value: _vm.form.set_time,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "set_time", $$v)
                        },
                        expression: "form.set_time"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "点货人" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { multiple: "", filterable: "" },
                        model: {
                          value: _vm.form.admin_ids,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "admin_ids", $$v)
                          },
                          expression: "form.admin_ids"
                        }
                      },
                      _vm._l(_vm.search_ops.admin, function(item) {
                        return _c("el-option", {
                          key: item.admin_id,
                          attrs: {
                            label: item.admin_name,
                            value: item.admin_id
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "颜色" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { multiple: "", filterable: "" },
                        model: {
                          value: _vm.form.co_ids,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "co_ids", $$v)
                          },
                          expression: "form.co_ids"
                        }
                      },
                      _vm._l(_vm.search_ops.colors, function(item) {
                        return _c("el-option", {
                          key: item.co_id,
                          attrs: { label: item.co_val, value: item.co_id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否带配件" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.form.is_parts,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_parts", $$v)
                          },
                          expression: "form.is_parts"
                        }
                      },
                      _vm._l(_vm.search_ops.is_suit, function(item) {
                        return _c("el-option", {
                          key: item.key,
                          attrs: { label: item.label, value: item.key }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "举报维度" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { multiple: "", filterable: "" },
                        model: {
                          value: _vm.form.storage_report_class_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "storage_report_class_id", $$v)
                          },
                          expression: "form.storage_report_class_id"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "无举报", value: "-1" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: {
                            label: "全部举报类型(不含无举报)",
                            value: "0"
                          }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.search_ops.storage_report, function(item) {
                          return _c("el-option", {
                            key: item.class_id,
                            attrs: {
                              label: item.class_name,
                              value: item.class_id
                            }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否套装" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.form.is_suit,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_suit", $$v)
                          },
                          expression: "form.is_suit"
                        }
                      },
                      _vm._l(_vm.search_ops.is_suit, function(item) {
                        return _c("el-option", {
                          key: item.key,
                          attrs: { label: item.label, value: item.key }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "入库来源" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { multiple: "" },
                        model: {
                          value: _vm.form.stock_source,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "stock_source", $$v)
                          },
                          expression: "form.stock_source"
                        }
                      },
                      _vm._l(_vm.search_ops.stock_source, function(item) {
                        return _c("el-option", {
                          key: item.key,
                          attrs: { label: item.label, value: item.key }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "单个任务仓位数" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "单个任务仓位数" },
                      model: {
                        value: _vm.form.space_num,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "space_num", $$v)
                        },
                        expression: "form.space_num"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.submit } },
              [_vm._v("保存")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { border: "1px solid #ddd" } },
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "50px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex"
                  },
                  attrs: { span: 24 }
                },
                [
                  _c("el-col", { attrs: { span: 1 } }, [_vm._v("商家：")]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { span: 8 }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            "remote-method": _vm.fetchSupply,
                            remote: "",
                            filterable: ""
                          },
                          on: { change: _vm.add_supply },
                          model: {
                            value: _vm.supply_id,
                            callback: function($$v) {
                              _vm.supply_id = $$v
                            },
                            expression: "supply_id"
                          }
                        },
                        _vm._l(_vm.search_ops.supply, function(item) {
                          return _c("el-option", {
                            key: item.supply_id,
                            attrs: {
                              value: item.supply_id,
                              label: item.supply_name
                            }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", size: "mini" },
                          on: { click: _vm.selectCat }
                        },
                        [_vm._v("编辑分类")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "0" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.tableLoading,
                          expression: "tableLoading"
                        }
                      ],
                      ref: "multipleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        height: "600",
                        data: _vm.select_supply,
                        "tooltip-effect": "dark"
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", width: "55" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "supply_name",
                          label: "商家名称",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "first_cat",
                          label: "商品一级分类",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "second_cat",
                          label: "商品二级分类",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "third_cat",
                          label: "商品三级分类",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "", label: "操作", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "red" },
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function($event) {
                                        return _vm.delete_supply(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择分类",
            visible: _vm.cat_visible,
            width: "30%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.cat_visible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品分类" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.search_ops.category,
                      props: _vm.props,
                      clearable: ""
                    },
                    model: {
                      value: _vm.cat_ids,
                      callback: function($$v) {
                        _vm.cat_ids = $$v
                      },
                      expression: "cat_ids"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.cat_visible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.setCat } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2b6a8fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2b6a8fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/setting/TallyTaskSetting.vue
// module id = null
// module chunks = 